import React from 'react';

import VideoFooter from './VideoFooter';
import VideoReport from './VideoReport';
import ModalComponent from '../../../Common/Modal';
import alertMessage from '../../../config/alertMessage';
import { examNameAccordingToDB, flowPlayerVideoDisplayUrl } from '../../../../common/constant';
import FlashCard from '../../../../components/FlashCard';

function VideoDisplayUI({
  videoList,
  showFreePremium,
  videoId,
  isFlashCardHidden,
  setChildRef,
  title,
  urlId,
  urlIdQq,
  pdfFile,
  chapterName,
  getVideoUrl,
  goToPreviousVideo,
  goToNextVideo,
  moveToNotes,
  moveToPracticeQuestion,
  saveVideo,
  onReportVideo,
  onViewPDF,
  reportLoading,
  successAlert,
  toggleReportSection,
  isReportSectionOpen,
  setContent,
  isVideoSaved,
  reportContent,
  showPremiumModel,
  checkSubscription,
  toggleAlert,
  goPremium,
  moveToVideoLessons,
}) {
  return (
    <div>
      <div className='d-flex justify-content-between'>
        <h4> {chapterName}</h4>
        <button
          type='button'
          className='btn btn-primary pointer_class height-fit-content'
          onClick={moveToVideoLessons}
        >
          Back to Videos
        </button>
      </div>
      <div className='video_outer'>
        <div className='row'>
          <div className='col-sm-12'>
            <div className='d-flex justify-content-between'>
              <h5>{title}</h5>
              <div className='float-right text-right'>
                <i className='fa fa-angle-left ques_arrow pointer_class' onClick={goToNextVideo} />

                <i
                  className='fa fa-angle-right ques_arrow pointer_class'
                  onClick={goToPreviousVideo}
                />
              </div>
            </div>
          </div>
        </div>
        <div className='videos-main-wraper'>
          <div className='row videos-main-block'>
            <div className='col-xs-12 col-sm-9 col-md-9 video-show-section'>
              <div className='iframe-wraper'>
                {urlIdQq ? (
                  <iframe
                    className='embed-responsive-item'
                    allowFullScreen
                    width='100%'
                    height='100%'
                    position='absolute'
                    top='10'
                    left='0'
                    src={flowPlayerVideoDisplayUrl(urlIdQq)}
                    sandbox='allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'
                    title='0'
                    byline='0'
                    portrait='0'
                    frameborder='10'
                  />
                ) : (
                  <iframe
                    width='100%'
                    allowFullScreen='1'
                    height='100%'
                    src={`https://www.youtube.com/embed/${urlId}?wmode=opaque&amp;rel=0&amp;autohide=1&amp;showinfo=0&amp;wmode=transparent&amp;modestbranding=1 `}
                    sandbox='allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'
                    frameBorder='0'
                  />
                )}
              </div>
            </div>
            <div className='col-xs-12 col-sm-3 col-md-3 video-tag-heading'>
              <div className='link_list_wrap'>
                {videoList.map((item, index) => (
                  <div key={item.id}>
                    <div className='full-width' key={item.id}>
                      <div className='videotitle' key={item.id} value={item.id}>
                        {showFreePremium === 'true' || showFreePremium === true ? (
                          item.free === 1 ? (
                            <div className='video-type-free'>Free</div>
                          ) : (
                            <div className='video-type-primum'>Premium</div>
                          )
                        ) : (
                          <div />
                        )}
                        <button
                          type='button'
                          name='videourl'
                          id={item.id}
                          className={item.id === videoId ? 'active' : ''}
                          onClick={() => getVideoUrl(index)}
                          value={item.url}
                        >
                          <div className='text-overflow'>{item.title}</div>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <VideoFooter
        rowClassName='my-3'
        moveToNotes={moveToNotes}
        moveToPracticeQuestion={moveToPracticeQuestion}
        saveVideo={saveVideo}
        onViewPDF={onViewPDF}
        isVideoSaved={isVideoSaved}
        videoId={videoId}
        pdfFile={pdfFile}
        toggleReportSection={toggleReportSection}
        showFreePremium={showFreePremium}
        checkSubscription={checkSubscription}
      />
      <br /> <br />
      <FlashCard
        item={{ id: videoId }}
        type='video'
        isFlashCardHidden={isFlashCardHidden}
        ref={setChildRef}
        exam='soa_p'
      />
      {isReportSectionOpen ? (
        <VideoReport
          videoId={videoId}
          reportLoading={reportLoading}
          successAlert={successAlert}
          toggleReportSection={toggleReportSection}
          setContent={setContent}
          reportContent={reportContent}
          onReportVideo={onReportVideo}
        />
      ) : null}
      <div>
        <ModalComponent
          goPremium={goPremium}
          toggleAlert={toggleAlert}
          alert_status={showPremiumModel}
          MessageContent={alertMessage.messageContent_soa_p}
          exam={examNameAccordingToDB.SOA_P}
        />
      </div>
    </div>
  );
}

export default VideoDisplayUI;



// WEBPACK FOOTER //
// ./src/views/SOA/Probability/VideoDisplay/VideoDisplayUI.jsx